export enum EDemandRequestStep {
  DEAL_TYPE,
  PHONE,
}
